module.exports = __webpack_public_path__ + "static/media/1.25deb7c1.jpg";